export default {
	TITLE: 'Tile layouts',
	ADDED: 'Tile layout added!',
	EDITED: 'Tile layouts edited!',
	DELETED: 'Tile layout deleted!',
	POS_CONFIGURATION_LAYOUT: 'Pos configuration layout',
	TILE_LAYOUT_GROUP: 'Tile layout groups',
};
